var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgXBadgeSize3 = function SvgXBadgeSize3(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1C2024",
    fillRule: "evenodd",
    d: "M4.195 4.195c.26-.26.683-.26.943 0L8 7.057l2.862-2.862a.667.667 0 1 1 .943.943L8.943 8l2.862 2.862a.667.667 0 1 1-.943.943L8 8.943l-2.862 2.862a.667.667 0 1 1-.943-.943L7.057 8 4.195 5.138a.667.667 0 0 1 0-.943",
    clipRule: "evenodd"
  })));
};
export default SvgXBadgeSize3;